import { Stack, Tooltip, Typography } from '@mui/material';
import type { BackupPolicyConfig } from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';
import useBackupVaults from '@/data/vaults/useBackupVaults';

import BackupPolicyPopperCard from './BackupPolicyPopperCard';

import { SnapshotIndicator } from '../snapshots/SnapshotIndicator';

interface BackupPolicyTagProps {
  policy: BackupPolicyConfig;
  disableTooltip?: boolean;
}

export default function BackupPolicyTag({
  policy,
  disableTooltip,
}: BackupPolicyTagProps) {
  const { vaults, isLoading: isLoadingVaults } = useBackupVaults();

  const distinctVaults = Array.from(
    new Set(policy.schedules.map((schedule) => schedule.vaultId))
  );

  return (
    <>
      <Tooltip
        disableHoverListener={disableTooltip}
        disableInteractive={false}
        leaveTouchDelay={2000}
        disableFocusListener
        slotProps={{
          tooltip: {
            sx: {
              maxWidth: '400px',
              backgroundColor: 'transparent',
            },
          },
        }}
        title={
          !isLoadingVaults ? (
            <BackupPolicyPopperCard policy={policy} vaults={vaults} />
          ) : undefined
        }
      >
        <Stack
          display='inline-flex'
          alignItems='center'
          direction='row'
          gap='8px'
          sx={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: policy.enabled
              ? 'var(--mui-palette-primary-main)'
              : 'transparent',
            backgroundColor: policy.enabled
              ? 'transparent'
              : 'var(--mui-palette-background-disabled)',
            borderRadius: '4px',
            padding: '4px 8px',
          }}
        >
          {!isLoadingVaults &&
            distinctVaults.map((vid, index) => {
              const v = vaults.find((v: BackupVault) => v.id === vid);
              return (
                <SnapshotIndicator
                  key={index}
                  backgroundColor={v?.backgroundColor || null}
                />
              );
            })}
          <Typography
            component='span'
            variant='subtitle2'
            sx={{ fontSize: '12px' }}
          >
            {policy.name}
          </Typography>
        </Stack>
      </Tooltip>
    </>
  );
}
